import { env } from "@app/resolveModule/env";

enum UiLanguage {
	en = "en",
	ru = "ru",
}

export enum ContentLanguage {
	en = "en",
	ru = "ru",
	es = "es",
	zh = "zh",
	hi = "hi",
	fr = "fr",
	ar = "ar",
	pt = "pt",
	de = "de",
	ja = "ja",
	tr = "tr",
	ko = "ko",
	it = "it",
	pl = "pl",
	nl = "nl",
	cs = "cs",
	sv = "sv",
	uz = "uz",
	kk = "kk",
	fa = "fa",
}

export const defaultLanguage = UiLanguage.en;

export const overriddenLanguage = UiLanguage[env("DEFAULT_UI_LANGUAGE") as keyof typeof UiLanguage];

export const browserLanguage = (): UiLanguage | undefined => {
	if (typeof navigator === "undefined") return undefined;
	return UiLanguage[navigator.language?.split("-")[0] as keyof typeof UiLanguage];
};

export const resolveDefaultLanguage = (): UiLanguage => overriddenLanguage || browserLanguage() || defaultLanguage;

export const resolveLanguage = (current?: UiLanguage): UiLanguage => current || overriddenLanguage || defaultLanguage;

export default UiLanguage;
